<template>
  <div v-loading="isBusy">
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      element-loading-spinner="el-icon-loading"
      label-width="170px"
    >
      <el-tabs v-model="activeName">
        <el-tab-pane label="Common" name="common">
          <el-form-item label="Type" prop="type">
            <el-select v-model="form.type" :disabled="isEditMode">
              <el-option
                v-for="{ value, label } in typeList"
                :value="value"
                :key="value"
                :label="label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Schema" prop="schema">
            <el-select v-model="form.schema" :disabled="isEditMode">
              <el-option
                v-for="{ value, label } in schemaOptions"
                :value="value"
                :key="value"
                :label="label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Slug" prop="slug">
            <el-input v-model="form.slug" type="text" disabled></el-input>
          </el-form-item>
          <el-form-item label="Class" prop="class">
            <el-input v-model="form.class" type="text" disabled></el-input>
          </el-form-item>
          <el-form-item label="Name" prop="name">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
        </el-tab-pane>
        <el-tab-pane label="Config" name="config">
          <schema-table
            v-model="form.config"
            :schema="getConfigSchema"
            scope="config"
          ></schema-table>
        </el-tab-pane>
        <el-tab-pane label="URLs" name="urls">
          <el-form-item
            v-for="item in providerUrls"
            :key="item.name"
            :label="item.name"
          >
            <el-input :value="item.url" type="text" readonly></el-input>
          </el-form-item>
        </el-tab-pane>
      </el-tabs>
    </el-form>
    <button class="btn btn-purple px-4 mt-3" @click="store">Store</button>
  </div>
</template>

<script>
import BaseForm from "../form";
import SchemaTable from "./schema-table";

export default {
  extends: BaseForm,

  components: {
    SchemaTable,
  },

  props: {
    configSchema: Object,
    typeList: Array,
    schemaOptions: Array,
    providerUrls: Array,
  },

  data() {
    const form = {
      type: null,
      schema: null,
      name: null,
      slug: null,
      config: null,
      class: null,
    };

    return {
      form,
      rules: {
        type: [{ validator: this.fieldExternalValidator }],
        slug: [{ validator: this.fieldExternalValidator }],
        schema: [{ validator: this.fieldExternalValidator }],
        name: [{ validator: this.fieldExternalValidator }],
        class: [{ validator: this.fieldExternalValidator }],
        config: this.schemaRules("config", [
          { validator: this.fieldExternalValidator },
        ]),
      },
      activeName: "common",
    };
  },

  computed: {
    /**
     * @return {Object}
     */
    getConfigSchema() {
      return _.get(this.configSchema, "config");
    },
  },

  methods: {
    /**
     * @param {Object} model
     */
    initForm(model) {
      this.form = _.mapValues(this.form, (val, prop) =>
        _.get(model, prop, null)
      );
    },

    /**
     * @param {String} field
     * @param {Array} rules
     * @return {object}
     */
    schemaRules(field, rules = []) {
      const result = {};

      _.each(_.get(this.configSchema, "config"), (items) => {
        _.each(items, (val) => {
          _.set(result, val, rules);
        });
      });

      return result;
    },
  },
};
</script>
